export const descriptions = {
  carForm: {
    en: "Component for adding and editing an object in the database",
    ua: "Компонент для додавання та редагування обʼєкта в базі даних",
  },
  carList: {
    en: "Displays all objects with the ability to edit or delete them. When clicking the Edit button, the object's values become editable in the form, and the Add Car button changes its label to Update Car.",
    ua: "Відображає всі обʼєкти з можливістю редагування або видалення. При кліку на кнопку Edit значення параметрів об’єкту доступні для редагування в формі, а кнопка Add Car змінює назву на Update Car.",
  },
  carsOld: {
    en: "Filter component that displays objects based on a specified parameter.",
    ua: "Компонент-фільтр, який відображає обʼєкти за заданим параметром.",
  },
  carsAll: {
    en: "Displays all objects with the ability to perform bulk actions",
    ua: "Відображає всі обʼєкти з можливістю масових змін",
  },
};
